import React, { useState, useEffect,useRef} from 'react';
import { useParams } from 'react-router-dom';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Loader from '../common/loader';
import { BaseUrl } from '../common/config';
import Sidebar from '../common/sidebar';
import { http } from '../helper';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const EditPromotions = () =>{
   
    ///exit();
    const [loading,setLoading] = useState(true);
    const [inputFieldtitle, setInputFieldtitle] = useState([]); 
    const [existfilename, setExistFilename] = useState([]); 
    const [existImgfilename, setExistImgFilename] = useState([]);
    const [filepath, setFilePath] = useState([]); 
    const [Imgfilepath, setImgFilePath] = useState([]);
    const [fileinput, setFileInput] = useState([]); 
    const [errormsg,setErrormsg] = useState({});
    const [errmessage, setErrMessage] = useState({});
    const [alertPopup,setAlertPopup] = useState(false);
    const [alertMessage,setAlertMessage] = useState([]);
    const [visibleAlert,setVisibleAlert] = useState(false);
    const [visibleAlertPdf,setVisibleAlertPdf] = useState(false);
    const [visibleImageAlert,setVisibleImageAlert] = useState(false);
    const [visibleAlertImage,setVisibleAlertImage] = useState(false);
    const [deleteAlert,setDeleteAlert] = useState(false);
    const [deleteImageAlert,setDeleteImageAlert] = useState(false);
    const [isLoading,setIsLoading]= useState(false);
    const [bannerImage, setBannerImage] = useState(null); // Store the banner image
    const [isFeatured, setIsFeatured] = useState([]);  // For featured checkbox
    //const [sortOrder, setSortOrder] = useState(1);  
    const [status, setStatus] = useState([]);   
    const [selectedCategory, setSelectedCategory] = useState('');
    const [bannerDesktop, setBannerDesktop] = useState(null);
    const [bannerMobile, setBannerMobile] = useState(null);
    const [bannerDesktopPreview, setBannerDesktopPreview] = useState(null);
    const [bannerMobilePreview, setBannerMobilePreview] = useState(null);
    const [selectedImageType, setSelectedImageType] = useState(null);
    const [deleteMessage, setDeleteMessage] = useState('');
    const [isDesktopImageDeleted, setIsDesktopImageDeleted] = useState(false);
    const [isMobileImageDeleted, setIsMobileImageDeleted] = useState(false);
    const [deletedPdfFiles, setDeletedPdfFiles] = useState([]);
    const [existingDesktopImageUrl, setExistingDesktopImageUrl] = useState('');
    const [existingMobileImageUrl, setExistingMobileImageUrl] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [existingPdfFiles, setExistingPdfFiles] = useState([]);
    const [pdfFiles, setpdfFiles] = useState([]);
    const [deletedExistingPdfFiles, setDeletedExistingPdfFiles] = useState([]); // NEW: Track deleted PDFs
    const [promoUrl, setPromoUrl] = useState('');
    const [urlTarget, setUrlTarget] = useState('');  // For URL target
    const [isMonthlyPromo, setIsMonthlyPromo] = useState(false);  // For monthly promotions
    const [priceBandIds, setPriceBandIds] = useState([]);
    const [checkedBandState, setCheckedBandState] = useState([]);
    const [checkedBand, setCheckedBand] = useState([]);
    const isUrlCategory = selectedCategory === 'url';

   const pdfInputRef = useRef(null);
    const params = useParams();
    
    const routeChange = () =>{ 
        window.location.href='/promotions'
    }

 
    if(!sessionStorage.getItem("isLoggedIn")){
        window.location.href = '/';
    }
    if(JSON.parse(sessionStorage.getItem('authData')) != '' && !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_promotions'))
        {
          window.location.href = '/unauthorized';
        }
   
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await http.get(BaseUrl + `admin/editpromotions/${params.id}`);
          const data = response.data.data[0];
          setInputFieldtitle(data.Title || '');
          setSelectedCategory(data.Category || '');
          setPromoUrl(data.redirectUrl || '');
          setUrlTarget(data.urlTarget || '_self');
          setIsMonthlyPromo(data.InMonthlyPromo || false);
          const desktopImageUrl = getImageUrl(data.BannerImageDesktop);
          const mobileImageUrl = getImageUrl(data.BannerImageMobile);
          setBannerDesktopPreview(desktopImageUrl);
          setBannerMobilePreview(mobileImageUrl);
          setExistingDesktopImageUrl(extractRelativePath(data.BannerImageDesktop));
          setExistingMobileImageUrl(extractRelativePath(data.BannerImageMobile));
          setIsFeatured(data.InDownloads || false);
          //setSortOrder(data.sortOrder || 1);
          setStatus(data.Status || 'active');
          setFromDate(data.FromDate ? moment(data.FromDate, "YYYY-MM-DD").toDate() : '');
          setToDate(data.ToDate ? moment(data.ToDate, "YYYY-MM-DD").toDate() : '');
          
          // Set price bands
          if (data.PriceBandTobeExcluded) {
            const bandIds = data.PriceBandTobeExcluded.split(',').filter(id => id);
            setCheckedBand(bandIds);
          }
          setExistingPdfFiles(
            (data.PdfFiles || []).map((fullPath) => {
              const parts = fullPath.split('/');
              const filename = parts[parts.length - 1]; // e.g., "sample-pdf-123456-7890123.pdf"
          
              // Remove trailing "-numbers-numbers" before .pdf
              const match = filename.match(/^(.*?)-\d+-\d+\.pdf$/);
              const cleanedName = match ? `${match[1]}.pdf` : filename;
          
              return {
                fullPath: fullPath,
                displayName: cleanedName,
              };
            })
          );
           
        } catch (error) {
          console.error("Error fetching promotion data:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
      }, [params.id]);
      

      const getImageUrl = (path) => {
        const base = BaseUrl.replace(/\/$/, "");
        if (!path.startsWith('/')) {
          path = '/' + path;
        }
        return base + path;
      };
      const extractRelativePath = (fullUrl) => {
        if (!fullUrl) return "";
        const uploadIndex = fullUrl.indexOf("upload/");
        if (uploadIndex !== -1) {
          let relativePath = fullUrl.substring(uploadIndex);
          return relativePath.startsWith("/") ? relativePath.substring(1) : relativePath;
        };
        return fullUrl;
      };
    
      // Fetch price bands
      useEffect(() => {
        let URL1 = `${BaseUrl}admin/getpricebandids`;
        http
          .get(URL1)
          .then((response) => {
            let responseData = response?.data?.data;
            const uniquePriceBandIds = responseData.filter((item, index, self) =>
              index === self.findIndex((t) => t.accountPriceListId === item.accountPriceListId)
            );
            setPriceBandIds(uniquePriceBandIds);
            // Initialize checked state based on existing checkedBand
            const initialState = uniquePriceBandIds.map(band => 
              checkedBand.includes(band.accountPriceListId)
            );
            setCheckedBandState(initialState);
          })
          .catch((err) => {
            console.log(err);
          });
      }, [checkedBand]);
      
      const handleOnChangeBand = (position, e) => {
        const updatedCheckedState = checkedBandState.map((item, index) => {
          return index === position ? !item : item;
        });

        var updatedList = [...checkedBand];

        if (e.target.checked) {
          updatedList = [...checkedBand, e.target.value];
        } else {
          updatedList.splice(checkedBand.indexOf(e.target.value), 1);
        }
        setCheckedBand(updatedList);
        setCheckedBandState(updatedCheckedState);
      };
      
      const submitButton = (e) => {
        e.preventDefault();
        if (!formvalidation()) {
          return;
        }
       
        handleUpload();
      };
    
      const handleFromDateChange = (date) => {
        setFromDate(date);
        setErrormsg((prev) => ({ ...prev, fromDateErr: '' }));
        // If date is cleared (null/empty), disable the checkboxes
        if (!date) {
          setIsFeatured(false);
          setIsMonthlyPromo(false);
        }
        // if (date > toDate) {
        //   setErrormsg({ ...errormsg, toDateErr: "To Date cannot be before From Date!" });
        // } else {
        //   setErrormsg({ ...errormsg, toDateErr: "" });
        // }
      };
    
      const handleToDateChange = (date) => {
        if (date >= fromDate) {
          setToDate(date);
          setErrormsg({ ...errormsg, toDateErr: "" });
        } else {
          setErrormsg({ ...errormsg, toDateErr: "Invalid Date Range!" });
        }
        // If date is cleared (null/empty), disable the checkboxes
        if (!date) {
          setIsFeatured(false);
          setIsMonthlyPromo(false);
        }
      };

      const handleDateKeyDown = (e) => {
    // Allow only deletion keys (Delete, Backspace) and navigation keys
    const allowedKeys = ['Delete', 'Backspace', 'Tab', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
    
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
       
    const handleFileUpload = (event, type) => {
        const file = event.target.files[0];
        if (!file) return;
    
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        const fileType = file.type.toLowerCase(); 
        const fileSizeInBytes = file.size;
        const fileSizeInMB = (fileSizeInBytes / 1024 / 1024).toFixed(2); 
        const maxSizeMB = 2;
        let errorMessage = "";
        if (!allowedTypes.includes(fileType)) {
          errorMessage = "Only JPG, JPEG, and PNG files are allowed.";
        } else if (fileSizeInMB > maxSizeMB) {
          errorMessage = "File size must be 2MB or less.";
        }
    
        setErrormsg((prev) => ({ ...prev, [`${type}Err`]: errorMessage }));
        if (errorMessage) {
          event.target.value = "";
          return;
        }
    
    setErrormsg((prev) => ({ ...prev, [`${type}Err`]: "" }));

    if (type === "desktop") {
      setBannerDesktop(file);
      setBannerDesktopPreview(URL.createObjectURL(file));
    } else {
      setBannerMobile(file);
      setBannerMobilePreview(URL.createObjectURL(file));
    }
  };
    
  const eventhandlechange = (e) => {
    const { name, value } = e.target;
    if (name === 'inputFieldtitle') {
        setInputFieldtitle(value);
        setErrormsg((prevErrors) => ({
            ...prevErrors,
            inputFieldtitleerr: value.trim() ? "" : prevErrors.inputFieldtitleerr,
        }));
    }
};

  const handleUpload = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("Title", inputFieldtitle.trim());
      formData.append("Category",(selectedCategory));
      //formData.append("sortOrder", sortOrder);
      formData.append("Status", status);
      formData.append("createdBy", JSON.parse(sessionStorage.getItem("authData")).adminName);
      formData.append("pid", params.id);
      if (selectedCategory === 'url') {
        formData.append('redirectUrl', promoUrl.trim());
        formData.append('urlTarget', urlTarget);
        formData.append('fromDate', fromDate ? moment(fromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss') : '');
        formData.append('toDate', toDate ? moment(toDate).endOf('day').format('YYYY-MM-DD HH:mm:ss') : '');
        formData.append('InDownloads', isFeatured);
        formData.append('InMonthlyPromo', isMonthlyPromo);
      } else {
        formData.append('fromDate', moment(fromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
        formData.append('toDate', moment(toDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
        formData.append("InDownloads", isFeatured);
        formData.append("InMonthlyPromo", isMonthlyPromo);
      }
      formData.append("PriceBandTobeExcluded", checkedBand.toString());
      // Append actual PDF files
      if (pdfFiles && pdfFiles.length > 0) {
        pdfFiles.forEach((file) => {
          formData.append("pdfFiles", file);  // Send the actual file
        });
      }
    // Send metadata separately
    const pdfData = {
      newPdfFiles: pdfFiles.map(file => file.name),
      existingPdfFiles: existingPdfFiles,
      deletedPdfFiles: deletedExistingPdfFiles
    };
    formData.append("pdfData", JSON.stringify(pdfData));
      //Desktop Image Handling
      if (isDesktopImageDeleted) {
        formData.append("isDesktopImageDeleted", true);
          if (existingDesktopImageUrl) {
            formData.append("existingBannerImageDesktop", existingDesktopImageUrl);
          }
          if (bannerDesktop) {
            formData.append("bannerImageDesktop", bannerDesktop);
          }
      } else {
          formData.append("isDesktopImageDeleted", false);
            if (existingDesktopImageUrl) {
              formData.append("existingBannerImageDesktop", existingDesktopImageUrl);
            }
      }
      //Mobile Image Handling
      if (isMobileImageDeleted) {
        formData.append("isMobileImageDeleted", true);
          if (existingMobileImageUrl) {
            formData.append("existingBannerImageMobile", existingMobileImageUrl);
          }
          if (bannerMobile) {
            formData.append("bannerImageMobile", bannerMobile);
          }
      } else {
          formData.append("isMobileImageDeleted", false);
            if (existingMobileImageUrl) {
              formData.append("existingBannerImageMobile", existingMobileImageUrl);
            }
      }
      const response = await http.put(BaseUrl + 'admin/editpromotions', formData);
      console.log("API Response:", response.data);
      if (response.data.success === true) {
        setAlertMessage('Promotion Banner updated successfully');
        setAlertPopup(true);
      }
    } catch (error) {
      console.error("Error updating promotion:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (loading) return <Loader />;


  const hasExtension = (inputID, exts) => {
    var fileName = document.getElementById(inputID).value;
    return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
}

    const formvalidation = () => {
        let newErrors = {};
        let isValid = true;
    
    if (!inputFieldtitle.trim()) {
      newErrors.inputFieldtitleerr = "This field is required";
      isValid = false;
    }
    if (!selectedCategory) {
      newErrors.categoryErr = "Please select a category";
      isValid = false;
    }
    if (selectedCategory === 'url') {
      if (!promoUrl.trim()) {
        newErrors.promoUrlErr = "This field is required";
        isValid = false;
      } else if (!/^(https?:\/\/)/i.test(promoUrl.trim())) {
        newErrors.promoUrlErr = "Enter a valid URL (http/https)";
        isValid = false;
      }
      if(!urlTarget){
        newErrors.promoUrlTargetErr = "This field is required";
        isValid = false;
      }
    } else {
    if (!fromDate) {
      newErrors.fromDateErr = 'Please select a start date';
      isValid = false;
    }
    if (!toDate) {
      newErrors.toDateErr = 'Please select an end date';
      isValid = false;
    } else if (toDate < fromDate) {
      newErrors.toDateErr = "Invalid Date Range!";
      isValid = false;
    }
  }
    if (!bannerDesktop && !bannerDesktopPreview) {
      newErrors.desktopErr = "This field is required";
      isValid = false;
    }
    if (!bannerMobile && !bannerMobilePreview) {
      newErrors.mobileErr = "This field is required";
      isValid = false;
    }
    setErrormsg(newErrors);
    return isValid;
  };

    const handleRadioChange = (event) => {
    const { value } = event.target;
    setSelectedCategory(value);
    setErrormsg((prev) => ({ ...prev, categoryErr: '' }));
    if (value === 'url') {
      // Don't clear dates and checkboxes - allow setting them for URL too
    } else {
      setPromoUrl('');
    }
    };

    const alertPopupclose = () =>{
        setVisibleAlert(false);
    }
    const alertPopupImgclose =()=>{
        setVisibleImageAlert(false);
    }
    const deletepdf = ()=>{
        setVisibleAlert(true);
    }
    const deleteImage = ()=>{
        setVisibleImageAlert(true);
    }
   
    const deleteFreepdf =() =>{
    setDeleteAlert(true);
    setExistFilename('');
    setVisibleAlert(false);
   
    }

    const deleteBanImage = () => {
      if (selectedImageType === "desktop") {
        setBannerDesktopPreview(null);
        setBannerDesktop(null);
        setIsDesktopImageDeleted(true);
        setExistingDesktopImageUrl(existingDesktopImageUrl); 
      } else if (selectedImageType === "mobile") {
        setBannerMobilePreview(null);
        setBannerMobile(null);
        setIsMobileImageDeleted(true);
        setExistingMobileImageUrl(existingMobileImageUrl);
      }
      setVisibleImageAlert(false); 
  };
  
   const popupClose = (event) => {

        setVisibleAlertPdf(false);
        
}
  // New function to handle PDF file uploads
  const handlePdfUpload = (event) => {
    const files = Array.from(event.target.files);
    const maxSizeMB = 8;
    let errorMessage = "";
  
    const validFiles = [];
  
    // Iterate through the files and check the validation
    for (let file of files) {
      const fileType = file.type.toLowerCase();
      const fileSizeInMB = file.size / 1024 / 1024;
  
      if (fileType !== "application/pdf") {
        errorMessage = "Only PDF files are allowed.";
        break;
      }
  
      if (fileSizeInMB > maxSizeMB) {
        errorMessage = "Maximum file size is 8MB";
        break;
      }
  
      if (!pdfFiles.some(f => f.name === file.name)) {
        validFiles.push(file);
      }
    }
  
    // Handle error if any
    if (errorMessage) {
      setErrormsg((prev) => ({ ...prev, pdfFilesErr: errorMessage }));
      event.target.value = "";
      return;
    }
  
    setErrormsg((prev) => ({ ...prev, pdfFilesErr: "" }));
    
    // Append the valid files to the state
    setpdfFiles((prevFiles) => [...prevFiles, ...validFiles]);
  
    // Reset file input after selection
    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
  };
  
  const removePdf = (index) => {
    const updatedFiles = [...pdfFiles];
    updatedFiles.splice(index, 1);
    setpdfFiles(updatedFiles);
  
    // Clear input to allow re-selecting same file again
    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
  };
  
  const removeExistingPdf = (index) => {
    const removedFile = existingPdfFiles[index];
  
    // Track the deleted file
    setDeletedExistingPdfFiles((prev) => [...prev, removedFile]);
  
    // Remove from UI
    const updatedPdfFiles = existingPdfFiles.filter((_, i) => i !== index);
    setExistingPdfFiles(updatedPdfFiles);
  };
  


return (<section className="dashboard-block">
   {alertPopup && ( 
   <div className='custom-alert-pop common_alert_popup' style={{display: "block"}}>
    <div className='custom-alert-container'>
            <div className='custom-alert-wrap'>
                <div className='custom-alert-header'>
                    <h4>Alert</h4>
                </div>
                <div className='custom-alert-body'>
                    <p>{alertMessage}</p>

                    <div className='alert-buttons'>
                        <a onClick={routeChange} className="popup-alert-btn button">OK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    )}
    
 
        <Sidebar />

 
  <div className="dash-left">
   <Header/>
    <section className="cart-block">
    {!loading &&
    <div className="container">
    <h1 className="checkout-title">Edit Promotion Banner</h1>

    <div className="right-table-outer-wrap">
    {( isLoading ) ? (
                  <div className='loading-buffer'></div>
                ):(  
    
     <form method='post' className="addform editform promo-form freeproduct-fieldset" onSubmit={submitButton}>
    
          <div className="input-field col-3">
          <label>Title</label>
          <input type="text" value={inputFieldtitle} name="inputFieldtitle" onChange={eventhandlechange} className="form-control" placeholder="Title" /> 
          {errormsg.inputFieldtitleerr && (
            <div className="error-msg">{errormsg.inputFieldtitleerr}</div>
            )}
            </div>
       
          <div className="input-field col-1">
          <label>Select the category for this Promotion Banner</label>
          <div className="edit-free-cat-chks">
              {["pizza", "pasta", "burrito", "desserts", "url"].map((category, index) => {
                  let displayCategory = category === "pasta" 
                      ? "Pasta, Rice & Noodle Sauces" 
                      : category === "url"
                      ? "URL"
                      : category.charAt(0).toUpperCase() + category.slice(1);
                  return (
                      <div className="check-box" key={index}>
                          <input
                              type="radio"
                              id={`freeCat${index}`}
                              name="category"
                              value={category}
                              checked={selectedCategory === category}
                              onChange={handleRadioChange}
                          />
                          <label htmlFor={`freeCat${index}`}>{displayCategory}</label>
                      </div>
                  );
              })}
          </div>
          {errormsg.categoryErr && <div className="error-msg">{errormsg.categoryErr}</div>}
      </div>
      {isUrlCategory && (
        <>
        <div className="input-field col-2">
          <label>URL</label>
          <input
            type="text"
            className="form-control"
            placeholder="https://example.com"
            value={promoUrl}
            //readOnly={isReadOnly}
            onChange={(e) => {
              setPromoUrl(e.target.value);
              setErrormsg((prev) => ({ ...prev, promoUrlErr: "" }));
            }}
          />
          {errormsg.promoUrlErr && (
            <div className="error-msg">{errormsg.promoUrlErr}</div>
          )}
        </div>
        <div className="input-field col-2">
          <label>Target</label>
          {/* <div className="edit-free-cat-chks">
            <div className="check-box">
              <input
                type="radio"
                id="targetSelf"
                name="urlTarget"
                value="_self"
                checked={urlTarget === "_self"}
                disabled={isReadOnly}
                onChange={(e) => setUrlTarget(e.target.value)}
              />
              <label htmlFor="targetSelf">Same Window</label>
            </div>
            <div className="check-box">
              <input
                type="radio"
                id="targetBlank"
                name="urlTarget"
                value="_blank"
                checked={urlTarget === "_blank"}
                disabled={isReadOnly}
                onChange={(e) => setUrlTarget(e.target.value)}
              />
              <label htmlFor="targetBlank">New Window</label>
            </div>
          </div> */}
          <select className='urlwindow' value={urlTarget} onChange={(e) => {setUrlTarget(e.target.value);setErrormsg((prev) => ({ ...prev, promoUrlTargetErr: "" }))}} >
            <option value="">Select</option>
            <option value="_self">Same Window</option>
            <option value="_blank">New Window</option>  
          </select>
          {errormsg.promoUrlTargetErr && (
            <div className="error-msg">{errormsg.promoUrlTargetErr}</div>
          )}
        </div>
        </>
      )}
      <div className="input-field col-1">
        <label>Promotional Banner Validity Period</label>
      </div>
      <div className="input-field col-3">
        <label className='lbl-blk'>From Date</label>
        <DatePicker
          selected={fromDate}
          onChange= {handleFromDateChange}
          
          minDate={new Date()}
          placeholderText="Select From Date"
          dateFormat='dd-MM-yyyy'
          onKeyDown={handleDateKeyDown}
                   
                  className="form-control"
                />
                {errormsg.fromDateErr && <div className="error-msg">{errormsg.fromDateErr}</div>}
              </div>

      <div className="input-field col-3">
        <label className='lbl-blk'>To Date</label>
        <DatePicker
          selected={toDate}
          onChange= {handleToDateChange}
          
          minDate={new Date()}
          placeholderText="Select To Date"
          dateFormat='dd-MM-yyyy'
          onKeyDown={handleDateKeyDown}
          className="form-control"
        />
        {errormsg.toDateErr && <div className="error-msg">{errormsg.toDateErr}</div>}
      </div>             
       <div className="notification-field-set-wrap">
                  <div className="notification-field-set promo-field-set">
                    <label>Banner Image <span className="text-note">(Maximum Upload File Size: 2 MB)</span></label>

                    {/* Desktop Banner */}
                    <div className="input-field col-1">
                      <label>Desktop <span className="text-note">(Image required size to upload is 1080px X 120px)</span></label>
                      
                      <div className="flex align-center gap-10">
                        {!bannerDesktopPreview && (
                          <>
                          <input
                            type="file"
                            id="desktop_banner"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(e) => handleFileUpload(e, "desktop")}
                          />
                          <span className="text-note">(.jpg, .jpeg, .png files only allowed)*<br /><br /></span>
                         </>
                        )}
                        
                        {bannerDesktopPreview && (
                          <div className="upld-img-file">
                            <div className="upld-img-show">
                              <img src={bannerDesktopPreview} alt="Desktop Preview" />
                              
                              <a className='title-tooltip title-up delete-img' data-title='Delete'
                              onClick={() => {
                                setSelectedImageType("desktop");
                                setDeleteMessage("Are you sure you want to delete Desktop Banner Image?");
                                setVisibleImageAlert(true);
                                }}
                                >
                                  <i className="fa fa-trash" aria-hidden="true"></i></a>
                            </div>
                          </div>
                        )}
                      </div>
                      {errormsg.desktopErr && <div className="error-msg">{errormsg.desktopErr}</div>}
                    </div>

                    {/* Mobile Banner */}
                    <div className="input-field col-1">
                      <label>Mobile <span className="text-note">(Image required size to upload is 480px X 240px)</span></label>
                      
                      <div className="flex align-center">
                        {!bannerMobilePreview && (
                          <>
                          <input
                            type="file"
                            id="mobile_banner"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(e) => handleFileUpload(e, "mobile")}
                          />
                          <span className="text-note"> (.jpg, .jpeg, .png files only allowed)*</span>
                          </>
                        )}
                       

                        {bannerMobilePreview && (
                          <div className="upld-img-file">
                            <div className="upld-img-show">
                              <img src={bannerMobilePreview} alt="Mobile Preview" />
                             
                              <a className='title-tooltip title-up delete-img' data-title='Delete'
                              onClick={() => {
                                setSelectedImageType("mobile");
                                setDeleteMessage("Are you sure you want to delete Mobile Banner Image?");
                                setVisibleImageAlert(true);
                              }
                              }>
                                <i className="fa fa-trash" aria-hidden="true"></i></a>
                            </div>
                          </div>
                        )}
                      </div>
                      {errormsg.mobileErr && <div className="error-msg">{errormsg.mobileErr}</div>}
                    </div>
                </div>
            </div>
            {/* pdf option */}
          <div className="input-field col-1">
          <label>PDF for Download <span className="text-note">(Maximum Upload File Size: 8 MB)</span></label>

          <div className="flex flex-column">
            <div className="input-note-wrapper">
              <input
                type="file"
                accept="application/pdf"
                multiple
                onChange={handlePdfUpload}
                ref={pdfInputRef}
              />
              <span className="text-note">(.PDF files only Allowed)</span>
            </div>

            {/* Show selected files (new PDFs) below the "Choose File" input */}
            <div className="pdf-preview-list">
              {/* Render existing PDFs with a close icon */}
              {existingPdfFiles.length > 0 && (
                <div className="existing-pdf-list">
                  <h4>Existing PDFs:</h4>
                  <div className="pdf-chip-list">
                    {existingPdfFiles.map((file, index) => (
                      <div key={index} className="pdf-chip-item">
                        <a href={BaseUrl+`${file.fullPath}`} target="_blank" rel="noopener noreferrer">
                          {file.displayName} {/* Display the file path or name */}
                        </a>
                        <span
                          className="remove-pdf"
                          onClick={() => removeExistingPdf(index)} // Handle removal
                        >
                          X
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Render newly selected PDFs */}
              {pdfFiles.length > 0 && (
                <div className="new-pdf-list">
                  <h4>New PDFs:</h4>
                  <div className="pdf-chip-list">
                    {pdfFiles.map((file, index) => (
                      <div key={index} className="pdf-chip-item">
                        {file.name}
                        <span className="remove-pdf" onClick={() => removePdf(index)}>X</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Show "+" symbol for adding more files */}
              {pdfFiles.length > 0 && (
                <div className="add-more-files-section">
                  <span className="add-more-files" onClick={() => pdfInputRef.current.click()}>
                    + Add more files
                  </span>
                </div>
              )}
            </div>

            {errormsg.pdfFilesErr && <div className="error-msg">{errormsg.pdfFilesErr}</div>}
          </div>
        </div>
              {/* Featured Checkbox */}
              <div className="input-field col-1">
                <label forhtml="downloads">Display for Downloads</label> <span className="text-note font-sm"> (Choose a date range for promotional validity period to enable this checkbox)</span>
                <div className="check-box no-disable-chk">
                <input type="checkbox" id='setImg' className='check-box' checked={isFeatured} 
                onChange={(e) => {
                  //if (isReadOnly) return;
                  setIsFeatured(e.target.checked);
                }}
                disabled={!fromDate || !toDate}
                />
                <label for='setImg'>Yes</label>
                </div>
              </div>
              
              {/* Monthly Promotions Checkbox */}
              <div className="input-field col-1">
                <label forhtml='promotions'>Display for Monthly Promotions</label> <span className="text-note font-sm"> (Choose a date range for promotional validity period to enable this checkbox)</span>
                <div className="check-box no-disable-chk">
                <input type="checkbox" id='monthlyPromo' className='check-box' checked={isMonthlyPromo} 
                onChange={(e) => {
                  //if (isReadOnly) return;
                  setIsMonthlyPromo(e.target.checked);
                }}
                disabled={!fromDate || !toDate}
                />
                <label for='monthlyPromo'>Yes</label>
                
                </div>
              </div>

              {/* Price Bands to be excluded */}
              <div className="input-field">
                <label>Price Bands to be excluded from this Promotion</label>
                <br />  <br />
                {priceBandIds.map(
                  (priceBand, index) =>
                    <div className="check-box" style={{ display: "inline-block", width: "200px" }}>
                      <input
                        type="checkbox"
                        name="PriceBandTobeExcluded"
                        id={`PriceBandTobeExcluded${index}`}
                        value={priceBand.accountPriceListId}
                        onChange={(e) => handleOnChangeBand(index, e)}
                        checked={checkedBandState[index]}
                        //disabled={isReadOnly}
                      />
                      <label htmlFor={`PriceBandTobeExcluded${index}`}>
                        {priceBand.accountPriceListId}{" "}
                      </label>
                    </div>

                )}
              </div>
              <br />  <br />

              {/* Sorting Input */}
              {/* <div className="input-field col-4">
                <label className='full-width'>Sort Order</label>
                <input type="number" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} min="1" placeholder="Order (1 for top priority)" />
              </div> */}

                {/* Status Dropdown */}
              <div className="input-field col-1">
                <label className='full-width'>Status</label>
                <select className='col-4' value={status} onChange={(e) => setStatus(e.target.value)}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              
        <button type='submit'>Submit</button> &nbsp;&nbsp;&nbsp;
        <button type="button" onClick={routeChange}>Cancel</button>
        </form>)}
        </div>
        </div>
        }

       

       </section>
      <Footer/>
      </div>  
      {loading && <Loader />}
            
      {visibleAlertPdf === true &&
       <div className='custom-alert-pop' style={{display: "block"}}>
        <div className='custom-alert-container'>
            <div className='custom-alert-wrap'>
                <div className='custom-alert-header'>
                    <h4>Alert</h4>
                </div>
                <div className='custom-alert-body'>
                    <p>File size must be less than 5 MB.</p>

                    <div className='alert-buttons'>
                        <a onClick={popupClose} className="popup-alert-btn button">OK</a>
                    </div>
                </div>
            </div>
        </div>
       </div>}

       {visibleImageAlert && 
                <div className='custom-alert-pop paylater-popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                            <p>{deleteMessage}</p>

                                <div className='alert-buttons'>

                                    <a onClick={deleteBanImage} className="popup-alert-btn button" >OK</a>
                                    <a onClick={alertPopupImgclose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}    


      {visibleAlertImage === true &&
       <div className='custom-alert-pop' style={{display: "block"}}>
        <div className='custom-alert-container'>
            <div className='custom-alert-wrap'>
                <div className='custom-alert-header'>
                    <h4>Alert</h4>
                </div>
                <div className='custom-alert-body'>
                    <p>File size must be less than 2 MB.</p>

                    <div className='alert-buttons'>
                        <a onClick={popupClose} className="popup-alert-btn button">OK</a>
                    </div>
                </div>
            </div>
        </div>
       </div>}      
    </section>

   );

}
export default EditPromotions;